import React from 'react';
interface PanelHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  level?: 2 | 3;
}
export function PanelHeader({
  title,
  description,
  action,
  level = 3
}: PanelHeaderProps) {
  const Heading = level === 2 ? 'h2' : 'h3';
  return <div className="flex flex-wrap items-start justify-between gap-3 border-b border-line px-5 py-4" data-id="element-440" data-mp="3j2dgumipu8j6">
      <div className="min-w-0" data-id="element-441" data-mp="2vcsya4qh5daf">
        <Heading className="text-sm font-semibold text-ink" data-id="element-442" data-mp="2vc132v0shhko">{title}</Heading>
        {description && <p className="mt-1 max-w-xl text-[13px] leading-relaxed text-ink-muted" data-id="element-443" data-mp="2qercvd5kt1vs">
            {description}
          </p>}
      </div>
      {action && <div className="shrink-0" data-id="element-444" data-mp="34b4nc2bp030r">{action}</div>}
    </div>;
}